import { useState } from 'react';

const faqItems = [
  {
    id: 1,
    q: '陌陌影视需要注册才能观看吗？',
    a: '不需要。陌陌影视所有电影资源均支持免注册免费在线观看，打开网站即可直接搜索和播放你喜欢的影片，没有任何使用门槛。',
  },
  {
    id: 2,
    q: '电影画质怎么样？播放流畅吗？',
    a: '平台所有影片默认提供1080P高清画质，部分热门大片支持4K杜比视界。我们采用分布式CDN加速和极速播放引擎，确保观影过程流畅不卡顿，即点即播无需等待。',
  },
  {
    id: 3,
    q: '陌陌影视支持哪些设备观看？',
    a: '陌陌影视全面适配PC浏览器、手机浏览器和平板设备，无需下载任何App或插件。无论是在电脑大屏、手机小屏还是平板上，都能获得优秀的观影体验。',
  },
  {
    id: 4,
    q: '片源更新频率如何？能看最新上映的电影吗？',
    a: '我们保持每日50+部片源的更新速度，院线热映大片会在上映后第一时间上线高清版本。同时，站点首页设有「最新动态」模块，方便你随时了解最新上线的影片。',
  },
  {
    id: 5,
    q: '观影过程中遇到问题怎么办？',
    a: '如果遇到播放异常、页面错误或其他使用问题，欢迎通过「投稿联系」模块发送邮件反馈。我们的技术团队会在24小时内响应并处理你的问题。',
  },
];

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-question-line mr-1"></i>答疑解惑
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问答</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">关于陌陌影视，你关心的问题都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl border border-secondary-200/50 overflow-hidden"
            >
              <button
                onClick={() => toggle(item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="font-heading text-base font-bold text-foreground-950 pr-4">{item.q}</h3>
                <span className={`w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0 transition-transform duration-200 ${openId === item.id ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              {openId === item.id && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}